/**
 * Currency formatter for the kanban board (USD).
 * @param {number} v — value in USD
 * @returns {string}
 */
export const formatCurrency = (v = 0) => {
  if (!v) return "$0";
  if (v >= 1000000) {
    return `$${(Number(v) / 1000000).toFixed(1)}M`;
  }
  if (v >= 1000) {
    return `$${(Number(v) / 1000).toFixed(1)}K`;
  }
  return `$${Number(v).toFixed(0)}`;
};
